import * as React from 'react'
import { SeriesTemplate, CommonSeriesSettings, Legend } from 'devextreme-react/chart'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'
import { PlatformContext } from '../../../../components/context/platform'
import { sp } from '../../../../utils/platformSelect'

export const AlbumChart: React.FunctionComponent = ({ }) => {
    const platform = React.useContext(PlatformContext)
    const [groupBy, setGroupBy] = React.useState<string>(platform != 'create' ? 'tag_name' : 'membership')
    const groupByArray = [{ val: 'tag_name', display: 'Version' }, { val: 'membership', display: 'Membership' }]

    const [currentGroupByArray, setCurrentGroupByArray] = React.useState(groupByArray)

    React.useEffect(() => {
        if (platform != 'create' && currentGroupByArray.length != groupByArray.length) {
            setCurrentGroupByArray(groupByArray)
        } else if (platform == 'create') {
            setCurrentGroupByArray(groupByArray.slice(1))
        }
    }, [platform])

    const toolbarItems = GroupByType(currentGroupByArray, groupBy, (selected) => {
        setGroupBy(selected!)
    })

    return (
        <BPMChart title={sp(platform, { default: 'Albums', create: 'Sound Packs' })} subTitle={'Top 10'} type='bar'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/albums', options, signal)
            }} additionalParams={{ groupBy }} toolBarItems={() => toolbarItems} visualRangeEnd={10} series={{
                name: 'Downloads',
                valueField: 'count',
                argumentField: "album_name",
                smallValuesGrouping: { topCount: 100, mode: 'topN' }
            }}>
            {groupBy && <SeriesTemplate
                nameField={groupBy}
            />}
            <CommonSeriesSettings type='bar'
                valueField="count"
                argumentField="album_name">
            </CommonSeriesSettings>
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/AlbumChart.tsx